import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Telegram = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill={fill}
      {...rest}
      width={Sizes[size]}
      height={Sizes[size]}
    >
      <path d="M15.968 1.293c-.026-.128-.114-.23-.232-.269-.21-.044-.428-.028-.63.048 0 0-14.019 5.348-14.82 5.94-.172.128-.23.202-.259.289-.138.424.293.608.293.608l3.613 1.25c.061.01.124.007.183-.012.822-.551 8.27-5.543 8.7-5.711.068-.021.118 0 .1.052-.172.637-6.606 6.707-6.641 6.744-.035.031-.053.078-.049.126l-.337 3.744s-.142 1.168.956 0c.779-.826 1.527-1.512 1.9-1.844 1.242.91 2.579 1.917 3.156 2.441.195.202.46.31.732.3.34-.044.618-.307.7-.66 0 0 2.561-10.906 2.646-12.374.008-.143.021-.23.021-.337.004-.112-.007-.225-.032-.335z" />
    </svg>
  );
};

Telegram.displayName = 'Telegram';
